export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";